import React, { useEffect, useState, useContext, Component } from "react"
import { Link } from "react-router-dom";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { apiEndpoint } from "helpers/url_helper";

import {
    Col,
    Row,
    Card,
    CardBody,
    CardTitle,
    Modal,
    ModalBody,
    ModalHeader,
    Button,
    ModalFooter,
    Dropdown,
  } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { isEmpty, isUndefined } from "lodash";
import { useHistory } from 'react-router-dom';

const ChangePasswordModalComponent = (props) => {

    const [modalIsOpen, setModalIsOpen] = useState(false);

    const [alertmsg, setAlert] = useState([]);

    const [Password, setPassword] = useState(false);
    const [ConfirmPassword, setConfirmPassword] = useState(false);
    let history = useHistory();

    const toggle = () => {
        setAlert(null);
        setModalIsOpen(!modalIsOpen)
    }
  
    const SessionExpired = () => {
      console.log("SessionExpired Called");
      // sessionStorage.removeItem("authUser")
      sessionStorage.removeItem("userFullName")
      sessionStorage.removeItem("Clear_AuthUser")
      sessionStorage.removeItem("GetToChange")
      setAlert(null)
      history.push('/');
    }

    // check Password & Confirm Password
    const checkPasswords = (password,confirmPassword) => {
        const validRegExp = new RegExp(
          '^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$'
        );
        if(validRegExp.test(password) && validRegExp.test(confirmPassword) 
        && password.length >= 7 && password.length <= 15 
        && confirmPassword.length >= 7 && confirmPassword.length <= 15
        && password == confirmPassword){
          return true;
        }
        else{
          return false;
        }
    }

    const saveButton = () => {
        if(checkPasswords(Password,ConfirmPassword)){
            // UserValidated
            fetch(apiEndpoint + "/UserChangePassword",
            {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "UserID": props.UserData.UserID,
                "Password": Password,
                "Token": sessionStorage.getItem("Clear_AuthUser")
            })
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(result!=undefined)
                    {
                      if(result.status){
                        //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                        setAlert (
                          <ReactBSAlert
                            success
                            // title="Campus Selection Is Required!"
                            //onConfirm={() => setAlert(null)}
                            onConfirm={() =>  toggle()}
                            onCancel={() => setAlert(null)}
                            confirmBtnBsStyle="info"
                          >
                            {result.Message}
                          </ReactBSAlert>
                        )
                      }
                      else{
                        if(result.Message == "Session Expired! Please login again and change user password!"){
                          setAlert (
                            <ReactBSAlert
                              warning
                              // title="Campus Selection Is Required!"
                              onConfirm={() => SessionExpired()}
                              onCancel={() => setAlert(null)}
                              confirmBtnBsStyle="info"
                            >
                              {result.Message}
                            </ReactBSAlert>
                          )
                        }
                        else{
                          setAlert(
                            <ReactBSAlert
                              warning
                              // title="Campus Selection Is Required!"
                              onConfirm={() => setAlert(null)}
                              onCancel={() => setAlert(null)}
                              confirmBtnBsStyle="info"
                            >
                              {result.Message}
                            </ReactBSAlert>
                          )
                        }
                      }
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    //setError(error);
                }
            )
        }
    }

    return(
        <>
            {/* <Link className="btn btn-primary waves-effect waves-light" to="#" role="Button"
            onClick={toggle}><i className="mdi mdi-key"></i></Link> */}
            <Link 
            onClick={toggle}><i className="mdi mdi-key mdi-24px"></i></Link>
            {modalIsOpen==true}
            <Modal isOpen={modalIsOpen} style={{ maxWidth: "60%" }}>
                <ModalBody toggle={toggle}>
                    <AvForm className="needs-validation" onSubmit={saveButton}>
                        {alertmsg}
                        <h4>Change Password</h4>
                        <Row>
                            <Col md={6}>
                                <label for="UserName" className="mt-3">UserName</label>
                                <AvField
                                    name="UserName"
                                    placeholder="Enter UserName here"
                                    type="text"
                                    className="form-control"
                                    defaultValue={props.UserData.UserName}
                                    id="UserName"
                                    disabled
                                />
                            </Col>
                        </Row>

                        <Row>

                            <Col md={6}>
                            <label for="Password" className="mt-3">Password *</label>
                            <AvField
                                name="Password"
                                placeholder="Enter password here"
                                type="password"
                                className="form-control"
                                id="Password"
                                onChange={(event) => setPassword(event.target.value)}
                                validate={{
                                required: {value: true, errorMessage: 'Please enter password'},
                                pattern: {value: '^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$', errorMessage: 'Password must contain 7-15 characters with atleast one digit & a special character'},
                                minLength: {value: 7, errorMessage: 'Password must be between 7 and 15 characters'},
                                maxLength: {value: 15, errorMessage: 'Password must be between 7 and 15 characters'}
                                }}
                                required
                            />
                            </Col>

                            <Col md={6}>
                            <label for="ConfirmPassword" className="mt-3">Confirm Password *</label>
                            <AvField
                                name="ConfirmPassword"
                                placeholder="Enter password here"
                                type="password"
                                className="form-control"
                                id="ConfirmPassword"
                                onChange={(event) => setConfirmPassword(event.target.value)}
                                validate={{
                                required: {value: true, errorMessage: 'Please enter password'},
                                pattern: {value: '^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$', errorMessage: 'Password must contain 7-15 characters with atleast one digit & a special character'},
                                minLength: {value: 7, errorMessage: 'Password must be between 7 and 15 characters'},
                                maxLength: {value: 15, errorMessage: 'Password must be between 7 and 15 characters'},
                                match: {value: 'Password', errorMessage: 'Password does not match'}
                                }}
                                required
                            />
                            </Col>

                        </Row>
                        <hr></hr>

                        <Row>
                            <Col md={9}>
                            </Col>
                            <Col md={1}>
                                <Link className="btn btn-primary waves-effect waves-light" to="#" role="Button"
                                onClick={toggle}>Close</Link>
                            </Col>
                            <Col md={1}>
                                <button className="btn btn-primary waves-effect waves-light" to="#" role="Button"
                                >Submit</button>
                            </Col>
                        </Row>

                    </AvForm>
                </ModalBody>
            </Modal>
        </>
    )

};

export default ChangePasswordModalComponent;